<template>
  <div>
    <h4 v-html="title" class="help_title_content_css" v-if="null!=title"></h4>
    <div v-html="context" class="context_css" v-if="null!=context"></div>
    <img :src="imgUrl" class="img_url_help_css" v-if="null!==imgUrl">
  </div>
</template>

<script>
export default {
  name: 'ContentBack',
  data() {
    return {
      //参数
      issueId: Number(this.$route.query.issueId),
      title: null,
      context: null,
      imgUrl: null,
      helpList: {
        common: [
          // 常见问题
          {id: 1001, title: '性别填错了怎么办？', context: '为了保障平台的用户真实性，用户注册账号后性别是无法更改的。<br><br>若填错，请重新注册新账号。 <br>'},
          {id: 1002, title: '金币、宝石是什么，怎么获取？', context: '1.金币是什么，怎么获取？<br>' +
              '金币是平台奖励用户的虚拟货币单位，（金币超过1000将不再增加）男性用户可用于聊天消耗，女性用户暂未开发金币功能。<br><br>' +
              '获取途径：每日连续签到或完成任务即可获得，打开路径—【首页】右上角图标点击进入或进入【我的】打开【我的任务】<br>' +
              '<br>2.宝石是什么，怎么获取？<br>' +
              '宝石是平台消费的虚拟货币单位，宝石可用于用户聊天消耗、购买聊天礼物和兑换提现。<br><br>' +
              '获取途径：用户首次登录的新手任务获取，用户充值获取，打开路径—【我的】—【我的任务】—完成新手任务获取，或【我的】—【我的钱包】—完成充值获取<br>' +
              '   '},
          {id: 1003, title: '如何兑换宝石？', context:
              '进入【我的】—【我的钱包】点击【兑换】按钮，选择你需要兑换的金额即可兑换。',
            url: 'whatBean'},
          {id: 1004, title: '账号为何被封禁？', context: '违反以下平台规范<br>' +
              '<br>' +
              '（一）法律法规禁止的内容<br>' +
              '1.反对宪法所确定的基本原则的；<br>' +
              '2.危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br>' +
              '3.损害国家荣誉和利益的；<br>' +
              '5.宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；<br>' +
              '6.煽动民族仇恨、民族歧视，破坏民族团结的；<br>' +
              '7.破坏国家宗教政策，宣扬邪教和封建迷信的；<br>' +
              '8.散布谣言，扰乱经济秩序和社会秩序的；<br>' +
              '9.散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br>' +
              '10.侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；<br>' +
              '11.法律、行政法规禁止的其他内容。<br>' +
              '<br>' +
              '（二）广告及诈骗类（包括但不限于以下内容）<br>' +
              '1.留微信号、QQ号、手机号，其他平台账号ID或二维码等引导到其他平台的；<br>' +
              '2.在相册，头像等处上传其他游戏、社交平台等第三方平台以及销售类广告的；<br>' +
              '3.涉嫌诈骗、非法获利广告行为的；<br>' +
              '4.出售第三方软件、协议扰乱平台秩序的；<br>' +
              '5.恶意注册账号、买卖账号的；<br>' +
              '6.以一切形式冒充官方人员<br>' +
              '7.恶意诋毁平台；<br>' +
              '8.恶意扰乱平台规则、频繁无意义刷屏等行为的；<br>' +
              '9.冒充他人或者机构，利用他人的名义传播任何信息的；<br>' +
              '10.发布各类不实信息，诱骗信息等；<br>' +
              '11.使用外挂等作弊软件或者其他互联网漏洞来获取不正当利益的；<br>' +
              '<br>' +
              '（三）淫秽色情类（包括但不限于以下内容，不论直接或间接行为）<br>' +
              '1.散布淫秽、色情内容的；<br>' +
              '2.以色情为目的的情色文字，情色视频等内容，但不限于上述形式；<br>' +
              '3.宣传、分享、传播色情低俗的网站、视频等；<br>' +
              '4.利用平台进行贩卖色情视频、性交易等各种不正当交易的；<br>' +
              '<br>' +
              '(四)暴力赌博类<br>' +
              '1.散播人或动物被杀、致残以及枪击、刺伤、拷打等受伤情形的真实画面的；<br>' +
              '2.描绘暴力、自残等内容的；<br>' +
              '3.涉及令人不安的血腥场景的；<br>' +
              '4.出现以鼓励非法或鲁莽使用方式等为目的而描述真实武器的内容；<br>' +
              '<br>' +
              '（五）不良信息类<br>' +
              '1.使用夸张标题，内容与标题严重不符的<br>' +
              '2.带有性暗示、性挑逗等易使人产生性联想的<br>' +
              '3.展现血腥、惊悚、残忍等致人身心不适的<br>' +
              '4.煽动人群歧视、地域歧视等的<br>' +
              '5.宣扬低俗、庸俗、媚俗内容的<br>' +
              '6.其他对网络生态造成不良影响的内容<br>' +
              '<br>' +
              '请音柚的各位用户，遵守平台规范。同时，欢迎大家共同监督，对发现的违规行为及时在平台举报通道进行投诉举报。', url: 'sound'},
        ],
        appPlay: [
          // 音柚怎么玩
          {id: 1101, title: '关于“音柚”', context: '在音柚，你可以通过文字互动、多种快速匹配、每天会为你个性化精准推荐多位真实用户等多种渠道，帮你快速找到你心仪的另一半，让你从此不再孤单！',
            url: 'match'},
          {id: 1102, title: '对方喜欢什么样的你', context: '相识要从多方面了解，你可以上传照片、写下文字、多发动态，让对方看到你的生活状态和兴趣爱好。<br>' +
              '对此我们也总结了受欢迎的用户的共同特征：<br>' +
              '<br>' +
              '1.本人真实的照片。（有的话会显得很真诚）<br>' +
              '<br>' +
              '2.写下自己个性的标签文字，会让你看起来真实有趣！<br>' +
              '<br>' +
              '3.你的照片也反应了你的生活，可以在动态里多多发布你平时生活中的照片。（如旅游、兴趣爱好、参加的活动、特别的收藏、可爱的动物、游戏或其他你自豪的事）<br>' +
              '<br>' +
              '相对完善的资料不光会增加对方对你的好感度，还能让聊天更有话题哦！<br>' +
              '  ',
            url: 'bottle'},
          {id: 1103, title: '在“音柚”，有哪些事不能做？', context: '在“音柚”，我们鼓励大家真诚尊重的交友，对于发布低俗、敏感、欺诈等内容，我们会毫不留情严肃处理！<br>' +
              '根据监测和用户的举报，我们会第一时间根据情节严重程度给予警告、永久封禁、移交相关执法机关等不同程度的处理。<br>' +
              '谢谢您的支持！我们会和您一起尽全力维护平台的环境～  ',
            url: 'cash'
          },
        ],
        match: [
          // 偶遇匹配问题
          {id: 1201,
            title: '声卡这么玩？”',
            context: '进入【偶遇】—【声卡】可查看部分异性用户发布语音信息，用户也可点击右上角按钮发布自己的语音信息，发布自己的语音后才可查看全部异性语音哦～<br>'
          },
          {id: 1202,
            title: '快速匹配怎么玩？ ',
            context: '进入【偶遇】—【速配】点击立即匹配按钮，系统会为您精准推荐优质用户，匹配会有30秒等待时间，在等待期间，需要另一用户也点击立即匹配按钮，才能匹配成功。<br>' +
              '匹配成功后可选择进行对话，也可以选择重新匹配。<br>' +
              '  ',
            url: 'gift'
          },
          {id: 1203,
            title: '相遇怎么玩？',
            context: '在音柚，你可以通过文字互动、多种快速匹配、每天会为你个性化精准推荐多位真实用户等多种渠道，帮你快速找到你心仪的另一半，让你从此不再孤单！<br>' +
              '  '
          },
        ],
        chat: [
          // 聊天攻略
          {id: 1301, title: '聊天消耗什么？', context: '聊天会消耗相应的宝石<br>' +
              '文字：10<br>' +
              '图片：10<br>' +
              '语音：10<br>' +
              '位置：10',
            url: 'destory'
          },
          {id: 1302,
            title: '聊天内容有隐私保护吗？',
            context: '我们和您一样重视隐私保护。我们将严格按照国家相关法律去保护用户隐私，除法律法规情形外，未经用户许可，平台不会向第三方透露您的任何个人信息。'
          },
          {id: 1303,
            title: '对方不回复我怎么办？',
            context: '对方暂时没来的及回复可能是因为在处理生活或工作上的事哦！如果打开消息提醒的话，对方看到会很快回复的。此外，也可参考这些方面：<br>' +
              '<br>' +
              '1.聊天问题是不是太过敏感或者无趣让对方没办法回复？<br>' +
              '<br>' +
              '2.对方最近太忙，可以试着在关心TA一下<br>' +
              '<br>' +
              '3.和TA分享一下自己生活中的小确幸吧，把快乐带给对方！<br>' +
              '<br>' +
              '4.最重要的是查看下自己资料是否补充的完整哦！让对方能充分了解你，容易让对方找到和你聊天的话题哦！'
          },
          {id: 1304, title: '如何送对方礼物？', context: '1.进入聊天对话界面，页面下方会有送礼选项，或者在发现界面，每个用户左下角也会有送礼选项，用户可用宝石购买的礼物赠送给心仪的对方。'},
        ],

        security: [
          // 账号安全
          {id: 1401, title: '如何删除/注销账户？', context: '你可以在设置—账户与安全中选中注销账户。<br>' +
              '<br>' +
              '注意：注销申发起开始的前90天为反悔期，重新登录账号即可终止注销流程，反悔期无登录行为，账号内宝石、金币、礼物数据将全部清空且无法恢复，对应账户手机号也将无法在注册音柚app，请仔细阅读后谨慎操作！',
            url: 'destory'
          },
          {id: 1402, title: '被骚扰怎么举报？', context: '如果你遇到低俗、敏感、欺诈等内容，请毫不留情的点击举报（聊天列表右上角图标点击打开，选择举报），我们会核实后严肃处理！<br>' +
              '<br>' +
              '如果给你带来体验上的不便，我们对此会深感歉意，感谢您的支持！我们会尽全力维护平台环境～'
          },
        ]
      },
      list: Array
    }
  },
  mounted() {
    let dark = this.$route.query.dark; // John
    let html = document.documentElement
    if (dark=='true') {
      html.classList.add('dark')
    } else {
      html.classList.remove('dark')
    }
    this.getList()
  },
  methods: {
    getList: function () {
      this.list = []
      if (this.issueId < 1100) {
        this.list = JSON.parse(JSON.stringify(this.helpList.common))
      } else if (this.issueId < 1200 && this.issueId > 1100) {
        this.list = JSON.parse(JSON.stringify(this.helpList.appPlay))
      } else if (this.issueId < 1300 && this.issueId > 1200) {
        this.list = JSON.parse(JSON.stringify(this.helpList.match))
      } else if (this.issueId < 1400 && this.issueId > 1300) {
        this.list = JSON.parse(JSON.stringify(this.helpList.chat))
      } else if (this.issueId < 1500 && this.issueId > 1400) {
        this.list = JSON.parse(JSON.stringify(this.helpList.security))
      }
      this.list.forEach(item => {
        if (this.issueId === item.id) {
          if (null != item.context && item.context.length > 0) {
            this.context = item.context
          }
          if (null != item.title && item.title.length > 0) {
            this.title = item.title
            document.title = '详情'
          }
        }
      })
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/view/pomelo/app/ContentBack.vue